<script setup>
import router from '../router'
import { onMounted } from 'vue'
import { store } from '@/store/index.js'

const oidcSignInCallback = () => {
  return store.dispatch('oidc/oidcSignInCallback')
  console.log('OIDC user:', store.state.oidc.user)
console.log('OIDC profile:', store.state.oidc.user?.profile)
}

onMounted(() => {
  oidcSignInCallback()
    .then((redirectPath) => {
      const redirectUrl = localStorage.getItem('redirectUrl')

      if (redirectUrl) {
        localStorage.removeItem('redirectUrl')

        router.push(redirectUrl).then(() => {
          window.location.reload()
        })

        return
      }

      router.push(redirectPath || '/')
    })
    .catch((err) => {
      console.error('signincallback error: ', err)
      router.push('/')
    })
})
</script>

<template>
  <div />
</template>